import { HOST_API } from 'src/config-global';
import {RecipeSearchInput, RecipeSearchOutput} from "@/types";

const RECIPE_LIST_API_URI = '/api/recipe/search';

export async function fetchRecipeList(data: RecipeSearchInput): Promise<RecipeSearchOutput> {
  const response = await fetch(`${HOST_API}${RECIPE_LIST_API_URI}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
    cache: 'no-store',
  });
  return response.json();
}


